import React, { useMemo } from 'react';
import { useRecoilValue } from 'recoil';

import { globalBgEffectActiveState } from '@atom/setting/globalStyle';
import ParticleEffect from '@components/effect/BackgroundEffect/ParticleEffect';
import ShootingStar from '@components/effect/ShootingStar/ShootingStar';
import { masterSet } from '@masterSetting/masterSet/masterSetting';
import {
  particleEffectOptionsState,
} from '@atom/setting/homepageSet';
import { bgEffSetState } from '@atom/setting/homeSettingState';

type Props = {};
function BackgroundEffect({ }: Props) {
  const bgEff = useRecoilValue(bgEffSetState);
  const globalBgEffectActive = useRecoilValue(globalBgEffectActiveState);
  const options = useRecoilValue(particleEffectOptionsState);
  const resolvedOptions = useMemo(
    () => bgEff?.options || options,
    [bgEff?.options, options],
  );

  if (!bgEff || !globalBgEffectActive) return null;

  return (
    <>
      {masterSet.backgroundEffect && bgEff?.isActive && (
        <ParticleEffect options={resolvedOptions} />
      )}

      {masterSet.shootingStar && bgEff?.shootingStar?.isActive && (
        <ShootingStar color={bgEff?.shootingStar?.color || '#fff'} />
      )}
    </>
  );
}

export default BackgroundEffect;
